import RfpBriefSection from "./RfpBriefSection";

export default RfpBriefSection;
